<template>
  <v-row no-gutters>
    <v-col cols="12">
      <card-title-row
        :straightTitle="hasCurrentDataTree ? currentDataTree.name : additionalModuleName"
        :has-buttons="hasCurrentDataTree"
        :has-back-button="hasCurrentDataTree"
        class="py-5"
        @action="pushRouterBack"
      >
        <template #buttons>
          <base-rounded-button
            icon="mdi-text-box-search"
            size="x-small"
            :tooltip="$i18n.t('sidebar.dataTree.showFullData')"
            @click="toggleFullData(currentDataTree)"
          />
        </template>
      </card-title-row>
      <sidebar-row>
        <template v-if="isFetched && mapPanelDataFetched">
          <template v-if="hasCurrentDataTree">
            <data-tree
              :data-tree="currentDataTree"
              :data-tree-result="currentDataTreeResult"
              :loading="currentDataTreeResultLoading"
              :headers="[
                { key: 'name', translationPath: 'sidebar.dataTree.name' },
                {
                  key: 'area',
                  translationStraight: `${this.$i18n.t('sidebar.dataTree.area')} [ha]`,
                  valueFormater: value => {
                    return (value / 10000).toFixed(4);
                  },
                },
              ]"
            />
            <data-tree-dialog
              v-if="fullDataLoaded"
              :is-visible.sync="fullDataVisible"
              :data-tree="currentDataTree"
              :data-tree-result="currentDataTreeResult"
              :data-tree-additional-cols="currentDataTreeAdditionalCols"
              :loading="currentDataTreeResultLoading"
            />
          </template>
          <template v-else>
            <ribbon-list
              :listItems="dataTreesArray"
              item-title-key="name"
              no-items-translation-path="admin.dataTree.noDataTrees"
              pagination-type="summary"
              @click="toggleDataTree"
            />
          </template>
        </template>
        <main-loader v-else />
      </sidebar-row>
    </v-col>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import CardTitleRow from '@/components/CardTitleRow';
import DataTree from '@/components/DataTree';
import MainLoader from '@/components/MainLoader';
import RibbonList from '@/components/RibbonList';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'DataTrees',
  components: {
    CardTitleRow,
    DataTree,
    DataTreeDialog: () => import('@/components/DataTreeDialog'),
    MainLoader,
    RibbonList,
    SidebarRow,
  },
  computed: {
    mapPanelDataFetched: get('map/mapPanelDataFetched'),
    additionalModuleName: get('admin/additionalModules@DATA_TREE_MODULE.verbose_name'),
    dataTrees: get('dataTree/dataTrees'),
    dataTreesArray() {
      return this.$_objectToArray(this.dataTrees);
    },
    currentDataTreeId() {
      return this.$route.params.id;
    },
    currentDataTree() {
      return this.dataTrees[this.currentDataTreeId];
    },
    hasCurrentDataTree() {
      return Boolean(this.currentDataTree);
    },
  },
  data: () => ({
    currentDataTreeResult: [],
    currentDataTreeAdditionalCols: [],
    fullDataLoaded: false,
    currentDataTreeResultLoading: false,
    fullDataVisible: false,
    isFetched: false,
  }),
  methods: {
    getDataTrees: call('dataTree/getDataTrees'),
    getDataTreeResultAction: call('dataTree/getDataTreeResult'),
    getDataSourceAttributeUniqueValues: call('layers/getDataSourceAttributeUniqueValues'),
    toggleDataTree(element) {
      this.$router.push({ name: 'dataTrees', params: { id: element.id } });
    },
    toggleFullData() {
      this.fullDataLoaded = true;
      this.fullDataVisible = true;
    },
    pushRouterBack() {
      this.$router.push({ name: 'dataTrees' });
    },
    async getDataTreeResult(id) {
      this.currentDataTreeResultLoading = true;
      try {
        this.currentDataTreeResult = await this.getDataTreeResultAction(id);
        const { datasource: dataSourceName, type_attribute: attributeName } = this.dataTrees[id];
        const r = await this.getDataSourceAttributeUniqueValues({ dataSourceName, attributeName });
        this.currentDataTreeAdditionalCols = Object.keys(r.values) || [];
      } catch {
        this.currentDataTreeResult = [];
        this.currentDataTreeAdditionalCols = [];
      } finally {
        this.currentDataTreeResultLoading = false;
      }
    },
    async init() {
      this.isFetched = false;
      await this.getDataTrees();
      this.isFetched = true;
    },
  },
  watch: {
    currentDataTreeId: {
      handler(nV) {
        if (nV || nV === 0) this.getDataTreeResult(nV);
      },
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
};
</script>
